/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllergenPropertyKind =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type CustomProductType = 'BOWL' | 'PLATE';

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DietaryPropertyKind = 'DAIRY' | 'FISH' | 'GLUTEN' | 'MEAT' | 'NUTS' | 'SOY';

export type LocationByAddressInput = {
  readonly address1?: string | null | undefined;
  readonly address2?: string | null | undefined;
  /** id for an address present in the current session. */
  readonly addressId?: string | number | null | undefined;
  readonly city?: string | null | undefined;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: string | null | undefined;
  readonly lat?: number | null | undefined;
  readonly lon?: number | null | undefined;
  readonly state?: string | null | undefined;
  readonly useCartRestaurant?: boolean | null | undefined;
  readonly zipcode?: number | null | undefined;
};

export type LocationStatus = 'CLOSED' | 'INVALID' | 'OPEN';

export type DeliveryMenuContentAddressQueryVariables = Exact<{
  addressId: string | number;
}>;

export type DeliveryMenuContentAddressQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export type DeliveryMenuContentRestaurantQueryVariables = Exact<{
  input: Types.LocationByAddressInput;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type DeliveryMenuContentRestaurantQuery = {
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly status: Types.LocationStatus;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly address: string;
          readonly phone: string;
          readonly isOutpost: boolean;
          readonly showDeliveryFeeDisclosure: boolean;
          readonly utcOffset: number | null;
          readonly isAcceptingOrders: boolean;
          readonly notAcceptingOrdersReason: string;
          readonly deliveryFee: number;
          readonly flexMessage: string | null;
          readonly hours: {
            readonly formatted: string | null;
            readonly permanent: ReadonlyArray<{
              readonly start: string;
              readonly end: string;
              readonly day: string;
            }>;
            readonly store: ReadonlyArray<{
              readonly start: string;
              readonly end: string;
              readonly day: string;
            }>;
          };
          readonly menu: {
            readonly __typename: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename: 'MenuCategory';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly description: string | null;
              readonly products: ReadonlyArray<{
                readonly __typename: 'Product';
                readonly id: string;
                readonly calories: number;
                readonly categoryId: string;
                readonly description: string;
                readonly isModifiable: boolean;
                readonly isCustom: boolean;
                readonly customType: Types.CustomProductType | null;
                readonly isSalad: boolean;
                readonly name: string;
                readonly outOfStock: boolean;
                readonly restaurantId: string;
                readonly slug: string;
                readonly throttleItem: boolean;
                readonly cost: number;
                readonly baseProduct: {
                  readonly __typename: 'BaseProduct';
                  readonly id: string;
                  readonly slug: string;
                  readonly lineageKey: string | null;
                  readonly proteinG: number | null;
                  readonly totalCarbsG: number | null;
                  readonly totalFatG: number | null;
                  readonly dietaryFiberG: number | null;
                  readonly calories: number | null;
                };
                readonly asset: { readonly url: string };
                readonly ingredients: ReadonlyArray<{
                  readonly __typename: 'Ingredient';
                  readonly id: string;
                  readonly name: string;
                  readonly totalCarbsG: number | null;
                  readonly proteinG: number | null;
                  readonly totalFatG: number | null;
                  readonly asset: { readonly url: string };
                }>;
                readonly label: {
                  readonly __typename: 'ProductLabel';
                  readonly id: string;
                  readonly name: string;
                } | null;
                readonly allergenProperties: ReadonlyArray<{
                  readonly __typename: 'AllergenProperty';
                  readonly id: string;
                  readonly name: Types.AllergenPropertyKind;
                }>;
                readonly dietaryProperties: ReadonlyArray<{
                  readonly __typename: 'DietaryProperty';
                  readonly id: string;
                  readonly name: Types.DietaryPropertyKind;
                }>;
              }>;
            }>;
          };
        };
        readonly estimateRange: { readonly start: number; readonly end: number };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const DeliveryMenuContentAddressDocument = gql`
  query DeliveryMenuContentAddress($addressId: ID!) {
    address(addressId: $addressId) {
      __typename
      id
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;

export function useDeliveryMenuContentAddressQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryMenuContentAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryMenuContentAddressQuery, DeliveryMenuContentAddressQueryVariables>({
    query: DeliveryMenuContentAddressDocument,
    ...options,
  });
}
export const DeliveryMenuContentRestaurantDocument = gql`
  query DeliveryMenuContentRestaurant($input: LocationByAddressInput!, $costChannel: CostChannel) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          __typename
          slug
          name
          city
          state
          zipCode
          address
          phone
          isOutpost
          showDeliveryFeeDisclosure
          hours {
            formatted
            permanent {
              start
              end
              day
            }
            store {
              start
              end
              day
            }
          }
          utcOffset
          isAcceptingOrders
          notAcceptingOrdersReason
          deliveryFee
          flexMessage
          menu {
            id
            __typename
            categories {
              id
              __typename
              name
              isCustom
              description
              products {
                id
                __typename
                baseProduct {
                  __typename
                  id
                  slug
                  lineageKey
                  proteinG
                  totalCarbsG
                  totalFatG
                  dietaryFiberG
                  calories
                }
                asset {
                  url
                }
                calories
                categoryId
                cost: channelCost(costChannel: $costChannel)
                description
                ingredients {
                  id
                  __typename
                  name
                  asset {
                    url
                  }
                  totalCarbsG
                  proteinG
                  totalFatG
                }
                isModifiable
                isCustom
                customType
                isSalad
                label {
                  id
                  __typename
                  name
                }
                allergenProperties {
                  id
                  __typename
                  name
                }
                dietaryProperties {
                  id
                  __typename
                  name
                }
                name
                outOfStock
                restaurantId
                slug
                throttleItem
              }
            }
          }
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
`;

export function useDeliveryMenuContentRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryMenuContentRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    DeliveryMenuContentRestaurantQuery,
    DeliveryMenuContentRestaurantQueryVariables
  >({ query: DeliveryMenuContentRestaurantDocument, ...options });
}
